module.exports = __webpack_public_path__ + "static/media/t1.4501edce.png";